<kh-dialog-header mat-dialog-title>Potential data overwrite </kh-dialog-header>
<div mat-dialog-content>
    <p>
        The following ({{ data.length }}) {{ sitesAliasLowerCase }} listed in the Excel spreadsheet already exist in
        your SMARTS app. Uploading this data will overwrite existing details for these {{ sitesAliasLowerCase }},
        including {{ siteAliasLowerCase }} name, address, latitude, longitude, and charge number.
    </p>
    <p><strong>How would you like to proceed?</strong></p>

    <kendo-grid
        [data]="data"
        [height]="240"
        class="kh-grid-header-left-align"
    >
        <kendo-grid-column
            field="siteNo"
            [title]="siteNumberTitle"
        ></kendo-grid-column>
    </kendo-grid>
</div>
<div
    mat-dialog-actions
    class="khts-mat-dialog-actions"
    align="end"
>
    <kh-app-text-button
        mat-dialog-close
        (clicked)="closeDialog()"
        >Cancel</kh-app-text-button
    >
    <kh-app-flat-button (clicked)="onConfirm()">Continue upload</kh-app-flat-button>
</div>
